import FilterListIcon from '@mui/icons-material/FilterList';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import { Tooltip } from '@mui/material';
import {
  ColumnsPanelTrigger,
  FilterPanelTrigger,
  Toolbar,
  ToolbarButton,
} from '@mui/x-data-grid-premium';
import { useLocalization } from '@/hooks/useLocalization';
import type { AccountsExportToolbarConfig } from './accountsExport';
import { AccountsExportMenuButton } from './accountsExportMenuButton';
import { GridQuickSearch } from '@/components/grids/gridQuickSearch';

interface AccountsGridToolbarProps {
  exportConfig: AccountsExportToolbarConfig;
  touchFriendly?: boolean;
}

export function AccountsGridToolbar({
  exportConfig,
  touchFriendly = false,
}: AccountsGridToolbarProps) {
  const { t } = useLocalization();
  const columnsLabel = t('grid.columns', 'Columns');
  const filtersLabel = t('filtersToolbar', 'Filters');
  const touchTargetStyles = touchFriendly
    ? { minHeight: 44, minWidth: 44 }
    : undefined;

  return (
    <Toolbar>
      <Tooltip title={columnsLabel}>
        <ColumnsPanelTrigger
          render={
            <ToolbarButton
              aria-label={columnsLabel}
              style={touchTargetStyles}
            />
          }
        >
          <ViewColumnIcon fontSize='small' />
        </ColumnsPanelTrigger>
      </Tooltip>

      <Tooltip title={filtersLabel}>
        <FilterPanelTrigger
          render={
            <ToolbarButton
              aria-label={filtersLabel}
              style={touchTargetStyles}
            />
          }
        >
          <FilterListIcon fontSize='small' />
        </FilterPanelTrigger>
      </Tooltip>

      <AccountsExportMenuButton
        config={exportConfig}
        touchFriendly={touchFriendly}
      />

      <GridQuickSearch touchFriendly={touchFriendly} />
    </Toolbar>
  );
}
